<template>
  <div class="top-warp">
    <div class="solution-box show-pc">
      <div class="top-title">针对企业痛点定制的数字化解决方案
      </div>
      <div class="">
        <hm-img type="images" imgName="solution" imgClass="solution-img" align="center"/>
      </div>
    </div>
    <div class="solution-box show-h5">
      <div class="top-title">
        针对企业痛点定制的<br/>数字化解决方案
        <div class="bgDot-box">
          <hm-img type="icons" imgName="bg_dot" imgClass="bgDot"/>
        </div>
      </div>
      <div class="">
        <hm-img type="images" imgName="solution-h5" imgClass="solution-img" align="center"/>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: '',
    props: {},
    components: {},
    data () {
      return {
       
      }
    },
    created () {
  
    },
    methods: {
      
    }
  }
  </script>

  <style scoped lang='less'>
  .top-warp {
    // background-color: #fff;
    .solution-box.show-pc {
      .margin-t-80 {
        margin-top: 80PX;
      }
      width: 1200PX;
      margin: 0 auto;
      .top-title {
        font-size: 36PX;
        color: #292F3A;
        letter-spacing: 0;
        text-align: center;
        line-height: 54PX;
        font-weight: 600;
        // margin-bottom: 40PX;
        padding: 80PX 0;
      }
    }
    .solution-box.show-h5 {
      .margin-t-80 {
        margin-top: 40PX;
      }
      margin: 0 auto;
      padding: 40PX 0;
      .top-title {
        font-size: 20PX;
        color: #292F3A;
        letter-spacing: 0;
        text-align: center;
        line-height: 30PX;
        font-weight: 600;
        width: 220PX;
        margin: 0 auto;
        position: relative;
        .bgDot-box {
          position: absolute;
          right: 10PX;
          top: -10PX;
        }
      }
    }
  }
  </style>

  
<style>
.solution-img {
  width: 100%;
}
.bgDot {
  width: 16PX;
}
</style>


// WEBPACK FOOTER //
// src/views/home/components/solution.vue